import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ManualPaymentSteps from './ManualPaymentSteps';
import LogoHeader from '../Inicio/components/LogoHeader';
import './Payment.css';

function Pago() {
  const reservaData = JSON.parse(sessionStorage.getItem('reserva_temp') || '{}');
  const { id, tipo } = useParams(); 
  const navigate = useNavigate();
  const [step, setStep] = useState(1);

  const preciosMap = {
    "1-hogar": "300", "1-local": "450",
    "2-hogar": "600", "2-local": "850",
    "3-hogar": "1000", "3-local": "1500"
  };

  const nombresMap = { "1": "Básico", "2": "VIP", "3": "Premium" };
  const imagenesMap = {
    "1": "/img/PAQUETE_1.jpg",
    "2": "/img/PAQUETE_2.jpg",
    "3": "/img/PAQUETE_3.jpg"
  };

  const montoFinal = preciosMap[`${id}-${tipo}`] || "0";
  const nombrePaquete = nombresMap[id] || "Personalizado";
  const imagenSeleccionada = imagenesMap[id] || "/img/PAQUETE_1.jpg";
   
  const productInfo = {
    price: montoFinal,
    comercio: "BAMBO EVENTOS",
    pedidoId: `BE-${Math.floor(Math.random() * 90000) + 10000}`,
    fecha: new Date().toLocaleDateString(),
    productDescription: `Paquete ${nombrePaquete} (${tipo ? tipo.toUpperCase() : ''})`
  };

  return (
    <div className="main-container">
      <LogoHeader />

      <div className="steps-bar">
        <div className={`step-item ${step === 1 ? 'active' : ''}`}>
          <span className="step-number">1</span> QR Yape/Plin
        </div>
        <div className={`step-item ${step === 2 ? 'active' : ''}`}>
          <span className="step-number">2</span> Comprobante
        </div>
        <div className={`step-item ${step === 3 ? 'active' : ''}`}>
          <span className="step-number">3</span> Confirmación
        </div>
      </div>

      <div className="ticket-info">
        <div className="ticket-header">
          <small>TOTAL A PAGAR:</small>
          <div className="ticket-price">S/. {productInfo.price}</div>
        </div>

        <div className="payment-body">
          {/* SECCIÓN IZQUIERDA (50% del ancho) */}
          <div className="info-section">
            <div className="details-wrapper">
              <div className="package-preview-container">
                <img 
                  src={imagenSeleccionada} 
                  alt="Vista previa" 
                  className="package-preview-img"
                  onError={(e) => e.target.src = "https://via.placeholder.com/300x150?text=Bambo+Eventos"}
                />
              </div>
              <h3 className="reserva-title">Detalles de Reserva</h3>
              <div className="detail-item"><span>Comercio:</span> <strong>{productInfo.comercio}</strong></div>
              <div className="detail-item"><span>Pedido:</span> <strong>{productInfo.pedidoId}</strong></div>
              <div className="detail-item"><span>Fecha Evento:</span> <strong>{reservaData.ven_fechaevento || productInfo.fecha}</strong></div>
              <div className="detail-item"><span>Ubicación:</span> <strong>{reservaData.loc_direccion || 'No especificada'} ({reservaData.loc_distrito || 'Sin distrito'})</strong></div>
              
              {/* CAMPO DE REFERENCIA AGREGADO */}
              {reservaData.loc_referencia && (
                <div className="detail-item">
                  <span>Referencia:</span> <strong>{reservaData.loc_referencia}</strong>
                </div>
              )}

              <div className="detail-item highlight"><span>Servicio:</span> <strong>{productInfo.productDescription}</strong></div>
            </div>
          </div>

          <div className="qr-section">
            <div className="qr-content-centered">
                <ManualPaymentSteps step={step} setStep={setStep} />
            </div>
          </div>
        </div>

        <div className="actions-footer">
          <button className="btn-cancel" onClick={() => navigate(-1)}>Cancelar Pago</button>
        </div>
      </div>
    </div>
  );
}

export default Pago;